import {
  Box,
  Breadcrumb,
  BreadcrumbItem,
  Container,
  Flex,
  Heading,
  Stack,
  // VStack,
  HStack,
  // Text,
  IconButton,
} from "@chakra-ui/react";

import { useMemo } from "react";
import { ChevronLeftIcon } from "@chakra-ui/icons";
import ArrowForwardIosRoundedIcon from "@material-ui/icons/ArrowForwardIosRounded";

// import User from "assets/profile.svg";
// import Bank from "assets/svg/icons-new/banks.svg";
// import Edit from "assets/svg/icons-new/edit.svg";
// import Support from "assets/svg/icons-new/support.svg";
// import Refer from "assets/svg/icons-new/refer.svg";
// import VerificationIcon from "../../../assets/svg/verification.svg";

//assets

// components
import Header from "components/dashHeader";
import Sidemenu from "components/sidemenu";
import BreadcrumbLink from "components/BreadcrumbLink/BreadcrumbLink";
import ReferrerList from "components/ReferrerList/ReferrerList";

// import AccountLink from "components/AccountLink/AccountLink";
//   import VerificationCard from "components/VerificationCard/VerificationCard";

// import { useIntercom } from "react-use-intercom";
// import ProfileShortInfo from "components/ProfileShortInfo/ProfileShortInfo";
import {
  useGetReferralsQuery,
  useGetReferralTradesQuery,
} from "services/arbitraryApi";
import AccountSidebar from "components/AccountSidebar/AccountSidebar";

// const isEmptyString = (val) => val === "" || val === undefined || val === null;

import { useParams, useHistory } from "react-router-dom";
import capitalize from "lodash/capitalize";

const AccountReferralList = (props) => {
  // const { boot } = useIntercom();
  const userData = props.userData;

  const { listType } = useParams();

  const history = useHistory();

  const { data, isLoading } = useGetReferralsQuery(userData?.userId);
  const { data: refTrades, isLoading: isRefTradesLoading } =
    useGetReferralTradesQuery(userData?.userId);

  const referredUsers = useMemo(
    () => (data?.referrals ?? []).map((r) => ({ ...r?.referredUserId })),
    [data]
  );

  const referredTrades = useMemo(
    () => (refTrades?.earnings ?? []).map((r) => ({ ...r?.referredUserId })),
    [refTrades]
  );

  const list = useMemo(() => {
    const map = {
      trades: referredTrades ?? [],
      registrations: referredUsers ?? [],
    };

    return map[listType ?? "registration"];
  }, [referredUsers, referredTrades, listType]);

  // console.log("ACCOUNT VERIFICAATION PAGE PROPS", props);

  return (
    <Box>
      <Sidemenu currentPage="Account" logoutUser={props.logout} />
      <Header />
      <Box as="section">
        <div className="account-container">
          <Flex className="flex">
            <Box flex=".8" borderRight="1px solid #D9DBE9" position="sticky">
              <Container maxW="calc(100% - 2em)" ml="10px">
                <Stack mb="48px">
                  <Heading>Account</Heading>
                  <Breadcrumb
                    className="animate__animated animate__fadeInDown"
                    separator={
                      <ArrowForwardIosRoundedIcon
                        style={{ fontSize: ".8em", color: "#6E7191" }}
                      />
                    }
                  >
                    <BreadcrumbItem>
                      <BreadcrumbLink to="/dashboard/account">
                        Account
                      </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbItem>
                      <BreadcrumbLink to={`/dashboard/account/refer`}>
                        Refer a friend
                      </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbItem isCurrentPage>
                      <BreadcrumbLink isCurrentPage>
                        {capitalize(listType)}
                      </BreadcrumbLink>
                    </BreadcrumbItem>
                  </Breadcrumb>
                </Stack>

                <AccountSidebar
                  pos="sticky"
                  top="0"
                  current="refer"
                  userData={userData}
                  logout={props.logout}
                />
              </Container>
            </Box>

            <Box flex="1">
              <Container
                maxW="lg"
                // ml={{ lg: "60px" }}
              >
                <Stack gridGap="20px" padding={"1rem"}>
                  <HStack>
                    <IconButton
                      variant="ghost"
                      aria-label="back"
                      maxW="fit-content"
                      icon={<Box fontSize="26px" as={ChevronLeftIcon} />}
                      _focus={{ shadow: "0 0 0 3px var(--focusColor)" }}
                      // _hover={{shadow: "0 0 0 3px var(--focusColor)" }}
                      onClick={() => history.push("/dashboard/account/refer")}
                    />
                    <Heading as="h4" fontSize="2xl">
                      All {capitalize(listType)}
                    </Heading>
                  </HStack>

                  <ReferrerList
                    data={list}
                    isLoading={isLoading || isRefTradesLoading}
                    listType={listType}
                  />
                </Stack>
              </Container>
            </Box>
          </Flex>
        </div>
      </Box>
    </Box>
  );
};

export default AccountReferralList;
